import Vue from 'vue'
import Router from 'vue-router'
import registered from '@/components/registered'
import login from '@/components/login'
import Layout from '@/components/Layout/index';
Vue.use(Router);

const router = new Router({
    // mode: 'history', //去掉url中的#
    routes: [{
            path: '/',
            name: 'login',
            component: login,
            meta: {
                noLogn: true,
            }
        },
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                noLogn: true,
            }
        },
        {
            path: '/registered',
            name: 'registered',
            component: registered
        },
        {
            path: '/admin',
            component: Layout,
            meta: {
                noLogn: true,
            },
            children: [{
                    path: '/admin',
                    name: '/admin',
                    component: () =>
                        import ('@/pages/index.vue'),
                    meta: {
                        // noLogn: true,
                    }
                }, {
                    path: '/report',
                    name: 'report',
                    component: () =>
                        import ('@/pages/report.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/report/:id/:type:/title',
                    name: 'report',
                    component: () =>
                        import ('@/pages/report.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/ZbMultiple',
                    name: 'ZbMultiple',
                    component: () =>
                        import ('@/pages/ZbMultiple.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/ZbMultiple/:id/:type:/title',
                    name: 'ZbMultiple',
                    component: () =>
                        import ('@/pages/ZbMultiple.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/Multiple',
                    name: 'Multiple',
                    component: () =>
                        import ('@/pages/Multiple.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/Multiple/:id/:type',
                    name: 'Multiple',
                    component: () =>
                        import ('@/pages/Multiple.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/customform',
                    name: 'customform',
                    component: () =>
                        import ('@/pages/customform.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/customform/:id/:type:/title',
                    name: 'customform',
                    component: () =>
                        import ('@/pages/customform.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/customMary',
                    name: 'customMary',
                    component: () =>
                        import ('@/pages/customMary.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/customMary/:id/:type:/title',
                    name: 'customMary',
                    component: () =>
                        import ('@/pages/customMary.vue'),
                    meta: {
                        // noLogn: true,
                    }
                },
                {
                    path: '/Permission',
                    name: 'Permission',
                    component: () =>
                        import ('@/pages/Permission.vue'),
                    meta: {
                        noLogn: true,
                    }
                },
                {
                    path: '/noaccess',
                    name: 'noaccess',
                    component: () =>
                        import ('@/pages/noaccess.vue'),
                    meta: {
                        noLogn: true,
                    }
                },
            ]
        },

    ]
})

router.beforeEach((to, from, next) => {
    var userInfo = (window.localStorage.getItem("email") && window.localStorage.getItem("token") && window.localStorage.getItem("memberOf")) ? true : false
    let s = !window.localStorage.getItem('date') || (window.localStorage.getItem('date') && new Date(parseInt(window.localStorage.getItem('date'))).getTime() + 24 * 60 * 60 * 1000 > (new Date().getTime()))
        //s为false，需要登录，为true，不需要登录
    if ((!to.meta.noLogn || (to.meta.noLogn && to.meta.noLogn != true)) && !s) {
        localStorage.clear()
        next({ path: '/' })
    }
    if ((!to.meta.noLogn || (to.meta.noLogn && to.meta.noLogn != true)) && !userInfo) {
        localStorage.clear()
        next({ path: '/' })
    }
    next();
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js